import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { handlePutRequest } from "../../services/PutTemplate";
import * as Yup from "yup";
import ZbizInput from "../../components/zbizInput/ZbizInput";
import classNames from "classnames";
import { Dropdown } from "primereact/dropdown";
import FileUpload from "../../components/fileUpload";

const UpdateCompanyForm = ({ formData, onCloseModal, getAllCompanies }) => {
  const [loading, setloading] = useState(false);
  const [loadingIcon, setloadingIcon] = useState("");
  const [loadedImage, setloadedImage] = useState(null);

  const validationSchema = Yup.object().shape({
    companyName: Yup.string().required("This field is required."),
    activeInactive: Yup.string().required("This field is required."),
  });

  const statusOptions = [
    { label: "Active", value: "1" },
    { label: "Inactive", value: "0" },
  ];

  useEffect(() => {
    if (formData) {
      formik.setFieldValue("companyName", formData?.companyName);
      formik.setFieldValue(
        "activeInactive",
        formData?.activeInactive.toString()
      );
      const base64 = formData?.companyLogo;
      // add data:image/png;base64 to base64
      const image = "data:image/png;base64," + base64;
      setloadedImage(image);
    }
  }, [formData]); // eslint-disable-line

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      companyName: "",
      activeInactive: "",
    },
    onSubmit: async (data) => {
      try {
        setloading(true);
        setloadingIcon("pi pi-spin pi-spinner");
        data["activeInactive"] = parseInt(data["activeInactive"]);
        await handlePutRequest(data, "company/update/" + formData.companyId);
        setloading(false);
        setloadingIcon("pi pi-save");
        getAllCompanies();
        onCloseModal();
      } catch (error) {
        setloading(false);
        setloadingIcon("pi pi-save");
      }
    },
  });
  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const props = {
    onChange: formik.handleChange,
    values: formik.values,
    isFormFieldValid: isFormFieldValid,
    getFormErrorMessage: getFormErrorMessage,
  };

  const handleUpload = (files, base64) => {
    console.log(files, base64);
    if (base64) {
      // remove data:image/png;base64, from base64
      base64 = base64.split(",")[1];
      formik.setFieldValue("companyLogo", base64);
    }
  };

  return (
    <div className="card Card__Round">
      <div className="Form__Header">
        <h1> Update Company </h1>
      </div>
      <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
        <div className="p-fluid p-formgrid p-grid">
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <ZbizInput
                required
                placeholder="Enter Company Name"
                label="Company Name"
                keyName="companyName"
                {...props}
              />
            </div>
          </div>
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <label
                htmlFor="activeInactive"
                className={classNames(
                  { "p-error": isFormFieldValid("activeInactive") },
                  "Label__Text"
                )}
              >
                Status<span className="Label__Required">*</span>
              </label>
              <Dropdown
                id="activeInactive"
                placeholder="Select Status"
                options={statusOptions}
                name="activeInactive"
                value={formik.values.activeInactive}
                onChange={formik.handleChange}
                className={classNames(
                  { "p-invalid": isFormFieldValid("activeInactive") },
                  "Dropdown__Round"
                )}
              />
              {getFormErrorMessage("activeInactive")}
            </div>
          </div>
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <label
                htmlFor="companyLogo"
                className={classNames(
                  { "p-error": isFormFieldValid("companyLogo") },
                  "Label__Text"
                )}
              >
                Company Logo<span className="Label__Required">*</span>
              </label>

              <FileUpload handleFile={handleUpload} loadedImage={loadedImage} />
            </div>
          </div>
        </div>

        <div className="Down__Btn">
          <Button
            disabled={loading}
            icon={loadingIcon || ""}
            iconPos="right"
            label={"Update"}
            className="Btn__Dark"
          />
        </div>
      </form>
    </div>
  );
};

export default UpdateCompanyForm;
